import Image from 'next/image'

export function Loader() {
  return (
    <div id="loader" className="absolute inset-x-0 inset-y-0 bg-page z-40 flex justify-center items-center">
      <Image priority fill style={{ objectFit: 'contain' }} alt="Loading..." src="/images/load.svg" />
    </div>
  )
}
